export default __webpack_public_path__ + "static/media/onboarding3.0557dede.svg";